import { useState, useRef, useCallback } from "react";

export function useOrderApplicationSelection() {
	const selectedRef = useRef(new Set());
	const [, forceRender] = useState(0);

	const toggleSelect = useCallback((id) => {
		const numericId = Number(id);

		if (selectedRef.current.has(numericId)) {
			selectedRef.current.delete(numericId);
		} else {
			selectedRef.current.add(numericId);
		}

		forceRender((prev) => prev + 1);
	}, []);

	const clearSelection = useCallback(() => {
		selectedRef.current.clear();
		forceRender((prev) => prev + 1);
	}, []);

	const getSelectedIds = useCallback(() => {
		return Array.from(selectedRef.current).sort((a, b) => a - b);
	}, []);

	return {
		selectedRef,
		toggleSelect,
		clearSelection,
		getSelectedIds,
	};
}
